import _ from 'lodash';
import moment from 'moment';

export default groupApptByDate;

/**
 * @name groupApptByDate
 * @description Funtion to group the appointments by appointment datetime.
 * @param {array} objects The array of appointments to group
 * @return {array} Returns an array of appointments grouped by dates
 */
function groupApptByDate(objects) {
  let dateGroups =
  _.chain(objects)
  .groupBy(function(object) {
    if (object.appointment.appointment_datetime !== null) {
      return moment(object.appointment.appointment_datetime)
      .format('MMMM Do, YYYY');
    }
    return 'No appointment date';
  })
  .toPairs()
  .map(function(object) {
    return {
      dateTime: moment(object[1][0].appointment.appointment_datetime)
      .format('MM-DD-YYYY'),
      date: object[0],
      appointments: object[1]
    };
  })
  .value();
  return dateGroups;
}



// WEBPACK FOOTER //
// ./utils/group-appts-by-date.js